// src/components/Leaderboard.js
import React from 'react';

const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  return input.replace(/[<>&"']/g, (match) => ({
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    "'": '&#x27;',
  }[match]));
};

function Leaderboard({ leaderboard, setGameState }) {
  return (
    <div className="leaderboard">
      <h2>Leaderboard</h2>
      {leaderboard.length === 0 ? (
        <p>No scores yet!</p>
      ) : (
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Player</th>
              <th>Floors Cleared</th>
              <th>Gold</th>
              <th>Kills</th>
              <th>Level</th>
              <th>Last Played</th>
            </tr>
          </thead>
          <tbody>
            {leaderboard.map((entry, index) => (
              <tr key={entry.id || index}>
                <td>{index + 1}</td>
                <td>{sanitizeInput(entry.character_name)} ({sanitizeInput(entry.username)})</td>
                <td>{Math.max(0, entry.floors_cleared)}</td>
                <td>{entry.gold || 0}</td>
                <td>{entry.kills || 0}</td>
                <td>{entry.level || 1}</td>
                <td>{new Date(entry.timestamp || entry.last_played).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <button onClick={() => setGameState('start')}>Back</button>
    </div>
  );
}

export default Leaderboard;